import React, {Fragment} from 'react';
import {Form, Field} from 'react-final-form';
import {Popup, Text, Select, Chip_input, Colour_input} from '../../../components';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import DeleteIcon from '@material-ui/icons/Delete';
import Button from '@material-ui/core/Button';
import { FieldArray } from 'react-final-form-arrays';
import arrayMutators from 'final-form-arrays';
import { connect } from 'react-redux';

function Link_listener_popup(props){

  function onSubmit(params){
    let result=JSON.parse(JSON.stringify(params));
    let links=[]; for(let l of params.links){links.push(l.link);}
    result.links=links;
    if(props.edit_id!=undefined){props.updateWorkspaceLinkListener(props.edit_id, result);}
    else{props.createWorkspaceLinkListener(result);}
  }


  let initial_values=undefined
  if(props.edit_id!=undefined){for(let w of props.workspace.workspace_link_listeners){if(w.id==props.edit_id){
    initial_values=JSON.parse(JSON.stringify(w));
    let links=[]; let i=0; for(let l of JSON.parse(initial_values.links)){links.push({id:i, link:l}); i+=1;}
    initial_values.links=links
    initial_values.field_fill_id=(w.workspace_field_fill==null)?null:w.workspace_field_fill.workspace_field_id
  }}}

  let custom_fields=[{id:null, name:'None'}]; for(let wf of props.workspace.workspace_fields){if(wf.entity_type=='COMPANY' && wf.data_type==6){custom_fields.push({id:wf.id, name:wf.name});}}


  return(
    <Form
      onSubmit={onSubmit}
      initialValues={initial_values}
      mutators={{
        ...arrayMutators
      }}
    >
      {form_props => (
        <form onSubmit={form_props.handleSubmit}>
        <Popup submit_button accept_button='Save' accept_button_click={()=>{form_props.form.submit(); form_props.form.reset(); props.handleClose();}} handleClose={props.handleClose} always_open title={(props.edit_id==undefined)?'workspace_link_listener_create_popup_label':'workspace_link_listener_update_popup_label'} content={
          <div style={{width:'95vw', maxWidth:'600px', minHeight:'400px'}}>
          <div style={{width:'calc(100% - 40px)', marginLeft:'20px', marginTop:'20px'}}>
              <Grid container style={{width:'calc(100% - 20px)', marginLeft:'10px', marginBottom:'0px'}}>
                <Grid item xs={6} sm={4}><div style={{width:'100%', marginTop:'-5px'}}><Text variant='not_outlined' color='transparent' title='Name' name='name'/></div></Grid>
                <Grid item xs={6} sm={4}><Select variant='not_outlined' color='transparent' title='Type' name='type' select_data={[{id:0, name:'Remove'}, {id:1, name:'Invisible'}, {id:2, name:'Primary highlight'}, {id:3, name:'Secondary highlight'}, {id:4, name:'Tertiary highlight'}]}/></Grid>
                <Grid item xs={6} sm={4}><Select variant='not_outlined' color='transparent' title='Auto fill' name='field_fill_id' select_data={custom_fields}/></Grid>
              </Grid>
              <Field name='links'>{(f)=><Field name='edited_values'>{(ef)=><Chip_input name='links' title='Links' edited_values={ef.input.value} onChangeEditedValues={ef.input.onChange} value={f.input.value} onChange={f.input.onChange} value_name='link'/>}</Field>}</Field>
          </div>
          </div>
        }/>
        </form>
      )}
    </Form>
  )
}


export default connect(ss, dd)(Link_listener_popup)


function ss(state){
  return{

  }
}

function dd(dispatch){
  return{
    createWorkspaceLinkListener:(data)=>{dispatch({type:'REQUEST_CREATE_WORKSPACE_LINK_LISTENER', payload:data});},
    updateWorkspaceLinkListener:(id, data)=>{dispatch({type:'REQUEST_UPDATE_WORKSPACE_LINK_LISTENER', id:id, payload:data});}
  }
}
